export const FormatDate = (date) => {
  const formDate = (string) => {
    if (string === null) {
      return "Pending";
    } else {
      var d = new Date(string);
      var mm = ("0" + (d.getMonth() + 1)).slice(-2);
      var dd = ("0" + d.getDate()).slice(-2);
      var yy = d.getFullYear();

      var myDateString = mm + "-" + dd + "-" + yy; //(US)

      return myDateString;
    }
  };
  return formDate(date);
};
export const FormatDateTime = (date) => {
  const formDate = (string) => {
    if (string === null) {
      return "Pending";
    } else {
      var d = new Date(string);
      var mm = ("0" + (d.getMonth() + 1)).slice(-2);
      var dd = ("0" + d.getDate()).slice(-2);
      var yy = d.getFullYear();
      var hh = d.getHours();
      var MM = d.getMinutes();

      var myDateString = mm + "-" + dd + "-" + yy + " " + hh + ":" + MM; //(US)

      return myDateString;
    }
  };
  return formDate(date);
};
